export const loadFlickity = require('bundle-loader?lazy&name=flickity!flickity');
